// export const api = 'http://192.168.30.56:8080'
// export const api = 'http://192.168.40.48:3100'
// export const api = 'http://192.168.30.32:3100'
// export const api = 'http://192.168.40.48:3100'
export const api = 'http://accounting-api.laodeveloper.com'
// export const api = 'https://api-accounting.soliserp.com'